import { requestHandler } from '@/api/base/requestHandler';
import queryString from 'query-string';

const getUrlWithQueryString = (url, queryObject = {}) => {
    return `${url}?${queryString.stringify(queryObject)}`;
};

export default {
    // servers
    getGameServers: (query) => {
        const url = getUrlWithQueryString('ticket/game-servers', query);

        return requestHandler({ type: 'get', url, isSilent: true });
    },

    // articles
    getArticles: (query) => {
        const url = getUrlWithQueryString('articles', query);

        return requestHandler({ type: 'get', url, target: 'data', isSilent: true });
    },

    // categories
    getCategories: (query) => {
        const url = getUrlWithQueryString('article-categories', query);

        return requestHandler({ type: 'get', url, target: 'data', isSilent: true });
    },

    // tickets
    getFeedbackQuestions: (query) => {
        const url = getUrlWithQueryString('ticket/feedback-questions', query);

        return requestHandler({ type: 'get', url, isSilent: true });
    },
    createTicket: (data) => {
        const url = 'ticket';

        return requestHandler({ type: 'post', url }, data);
    },
    uploadTicket: (data, query, fallbackErrorText) => {
        const url = getUrlWithQueryString('ticket/upload', query);

        return requestHandler({ type: 'post', url, isMultipart: true, fallbackErrorText }, data);
    },
    deleteUploadedImage: (query) => {
        const url = getUrlWithQueryString('ticket/delete', query)
        return requestHandler({ type: 'delete', url })
    },

    // common
    getAppConfig: (query) => {
        const url = getUrlWithQueryString('custom-config', query)

        return requestHandler({ type: 'get', url, isSilent: true })
    },

    // documents
    getDocuments: (query) => {
        const url = getUrlWithQueryString('documents', query)

        return requestHandler({ type: 'get', url })
    },

    getPreset: (query) => {
        const url = getUrlWithQueryString('presets', query)

        return requestHandler({ type: 'get', url, isSilent: true })
    },

    // from game (not our api)
    // docs: https://vip-checker.support.dev.nexters.team/docs#/default/get_data_for_sp_get_data_for_sp_post
    // getMeyaParams: (data) => {
    //     const url = process.env.VUE_APP_GAME_MEYA_API_URL
    //     const token = process.env.VUE_APP_GAME_MEYA_API_TOKEN
    //     const headers = { 'Authorization': `Bearer ${token}` }
    //
    //     return requestHandler({ type: 'post', url }, data, headers)
    // },
};
